import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LinkInBio from '../pages/link_in_bio/LinkInBio';
import Calendar from '../pages/calendar/Calendar';
import EventForm from '../pages/yoga-flow/EventForm';
import EventPage from '../pages/link_in_bio/EventPage';
import { DataProvider } from '../pages/link_in_bio/DataContext';
import { useState, useEffect } from 'react';

function AppRoutes() {
   
    return (
        <DataProvider>
      <Routes>
        {/* <Route path="/:companyname/create-event/yoga" element={<TokenHandler />}/> */}
        {/* <Route path="/create-event/:companyname" element={<TokenHandler />}/> */}
        <Route path="/biolink/:slug" element={<LinkInBio />} />
        <Route path="/biolink/:slug/:eventSlug" element={<EventPage />} />
        <Route path='/calendar/:slug' element={<Calendar/>}/>
        <Route path="/create-event/:companyname/" element={<EventForm />} />
        <Route path="/edit-event/:companyname/:slug" element={<EventForm />} />
      </Routes>
        </DataProvider>
    )
}
export default AppRoutes